<template>
  <div class="akl">
    <div class="bod-view-txt">
      <div class="os_noticeRes">
        <div class="widM padTM cont_Wrap">
          <!-- 설문 헤더 -->
          <SurveyHeader />

          <template v-if="infoAvailable">

            <!-- 설문 참가자 정보 -->
            <SurveyParticipantInfo v-if="isInitCompleted" />

            <!-- 참가 약관 -->
            <SurveyConsent v-if="existAttendant" />
          </template>

          <!-- 참가 액티비티 예약 -->
          <SurveyActivityList v-if="existAttendant && activityAvailable" />
          
          <hr style="border-top:1px solid #ddd; background:#f4f4f4;">

          <div class="widM txtC marTML" v-if="isInitCompleted">
            <button
              class="bt-akl-blue large NCAcmi_submit"
              :class="{ NCAcmi_submitNope: submitBtnDisabled }"
              @click="submitSurvey"
              :disabled="submitBtnDisabled"
            >제출</button>
          </div>
          <div class="padM disIb"></div>
        </div>
        <SurveyPopupLayer v-if="survey_popup">
          <component :is="popupComponent" />
        </SurveyPopupLayer>
        <SurveyPopupLayerActivity v-show="survey_activity_popup" />
        <SurveyPopupLayerInterestFee v-if="survey_interestFee_popup" />
      </div>
    </div>
    <SurveyLoading v-if="survey_loading" />
  </div>
</template>

<script>
import axios from 'axios'
import { mapState, mapGetters } from 'vuex'
import { SURVEY, FETCH_DATAS, ATTENDING_LIST, EXIST_ATTENDANT, MEMBER_ATTENDANTS, SET_ABO_UID, SET_LOADING, VALIDATE_DATA, SUBMIT_SURVEY, ACTIVITY_QUESTIONS, INFO_AVAILABLE, ACTIVITY_AVAILABLE, IS_VIP } from '@/store/actions/survey'
import { SurveyHeader, SurveyParticipantInfo, SurveyConsent, SurveyActivityList, SurveyLoading, SurveyPopupLayer, SurveyPopupLayerActivity, SurveyPopupLayerInterestFee } from './components'
import { getMessage } from '@/utils/survey'

export default {
  name: 'Survey',
  components: {
    SurveyHeader,
    SurveyParticipantInfo,
    SurveyConsent,
    SurveyActivityList,
    SurveyLoading,
    SurveyPopupLayer,
    SurveyPopupLayerActivity,
    SurveyPopupLayerInterestFee
  },
  data() {
    return {
      btnDisabled: false
    }
  },
  computed: {
    ...mapState(SURVEY, {
      abo_uid: state => state.abo_uid,
      survey_loading: state => state.loading,
      survey_popup: state => state.popup.open,
      popupComponent: state => state.popup.component,
      survey_activity_popup: state => state.popup_activity,
      survey_interestFee_popup: state => state.popup_interestfee,
      mode: state => state.mode,
      isInitCompleted: state => state.isInitCompleted,
      pinLevel: state => state.pin_level
    }),
    ...mapGetters(SURVEY, {
      attendingList: ATTENDING_LIST,
      existAttendant: EXIST_ATTENDANT,
      memberAttendants: MEMBER_ATTENDANTS,
      activities: ACTIVITY_QUESTIONS,
      infoAvailable: INFO_AVAILABLE,
      activityAvailable: ACTIVITY_AVAILABLE,
      isVip: IS_VIP
    }),
    submitBtnDisabled() {
      // 사업자가 존재하지 않거나, btnDisabled가 true
      return this.memberAttendants.length === 0 || this.btnDisabled;
    },
    showAlertAboutVipActivity() {
      return this.activityAvailable && this.isVip;
    }
  },
  methods: {
    async submitSurvey() {
      this.btnDisabled = true; // 중복 submit 으로 인한 중복 데이터 insert 방지
      try {
        // 입력 데이터 체크
        const errorMsg = await this.$store.dispatch(`${SURVEY}/${VALIDATE_DATA}`);
        if(errorMsg) {
          const [msg, elId] = errorMsg.split('|');
          alert(msg);
          elId && document.getElementById(elId).scrollIntoView({ behavior: 'smooth' });
          this.btnDisabled = false;
          return;
        }

        // 사용자 정보 입력/수정 가능하고
        // 동반가족 포함 4명 이상일 때 컨펌 얼럿 노출
        if(this.infoAvailable && this.attendingList.length > 3) {
          if(!confirm(getMessage('CONFIRM_ATTENDANT_RULE2'))) {
            this.btnDisabled = false;
            return false;
          }
        }
        
        const isSuccess = await this.$store.dispatch(`${SURVEY}/${SUBMIT_SURVEY}`);
        if(isSuccess) {
          alert(getMessage(this.activityAvailable ? 'ALERT_SUBMIT_ACTIVITY_SUCCESS' : 'ALERT_SUBMIT_INFO_SUCCESS'));
          this.$router.go(this.$router.currentRoute);
        }
      } catch (error) {
        alert(error.message);
        this.btnDisabled = false;
        this.$store.commit(`${SURVEY}/${SET_LOADING}`, false);
      }
    },
  },
  async mounted() {
    this.$store.commit(`${SURVEY}/${SET_LOADING}`, true);
    const s_code = 'CM';
    const wave_number = this.$route.params.wave_number;
    try {
      await this.$store.dispatch(`${SURVEY}/${FETCH_DATAS}`, { s_code, wave_number, abo_uid: this.abo_uid });
    } catch (error) {
      alert(error.message);
      console.error(error.stack);
      window.location.href = process.env.AMWAY_ROOT_URL;
    }
    this.$store.commit(`${SURVEY}/${SET_LOADING}`, false);
    // this.showAlertAboutVipActivity && setTimeout(() => alert('액티비티 경고 문구'), 0);
  },
  /**
   * 페이지 라우팅 되기 전에
   * SSO Login 체크, 서베이 코드 및 서베이 회차 validation
   * 
   */
  async beforeRouteEnter(to, from, next) {
    try {
        // SSO Login 체크
        const { data } = await axios.get(`${process.env.OCC_ROOT_URL}/sso/authorizeEvent`, { withCredentials: true });
        if(data.header.status === 'ERROR') {
          window.location.href = `${process.env.AMWAY_ROOT_URL}/login`;
        } else {
          const wave_number = to.params.wave_number;
          const abo_uid = atob(data.customerUid);
          if(Number(wave_number) === NaN || Number(wave_number) < 1) {
            alert(getMessage('ERROR_INVALID'));
            window.location.href = process.env.AMWAY_ROOT_URL;
            return next(false);
          }

          return next(vm => {
            vm.$store.commit(`${SURVEY}/${SET_ABO_UID}`, abo_uid);
          });
        }
      } catch (error) {
        console.error(`${error.message}(${error.status})`);
        alert(getMessage('ERROR_AUTHORIZE'));
        window.location.href = `${process.env.AMWAY_ROOT_URL}/login`;
        return next(false);
      }
  }
}
</script>

<style>
@import './font_kr.css';
@import url('https://www.amway.co.kr/_ui/responsive/theme-blue/css/style.css');
@import url('https://www.amway.co.kr/_ui/responsive/theme-blue/css/akl-lib.css');
@import url('https://www.amway.co.kr/_ui/responsive/theme-blue/css/base.css');
@import url('https://www.amway.co.kr/_ui/responsive/theme-blue/css/akl-common.css');
@import url('https://www.amway.co.kr/_ui/responsive/theme-blue/css/akl-common-new-v2.css');

body{margin:0 auto}
.bod-view-txt{padding-top:0}

/* radio btn */
.os_noticeRes .amway-theme .NCAcmi_radioBtn label{margin-bottom:0;}
.os_noticeRes .amway-theme .NCAcmi_radioBtn .radio-label input.amw-global-radio:checked + .amw-radio-overlay:before{background:#33597e; width:8px; height:8px; top:4px; left:4px;}
.os_noticeRes .amway-theme .NCAcmi_radioBtn .radio-label input.amw-global-radio:checked + .amw-radio-overlay:after{border:2px solid #33597e; width:18px; height:18px; border-radius: 50%; content: ''; display:block; top: 50%; left: 50%; transform: translate(-50%, -50%); position:absolute;}

/* 참가자 정보 */
.os_noticeRes .NCAcmi_cont01{display:flex; align-items: center; justify-content: space-between;}
.os_noticeRes .NCAcmi_cont01_radio{display:flex; justify-content:space-between;}
.os_noticeRes .NCAcmi_cont01_radio label .amw-label-radio-text{font-size:18px; font-weight:normal; position:relative; top:-3px;}

.os_noticeRes .NCAcmi_cont01_wrap .NCAcmi_cont01-1{display:flex; align-items: center; justify-content: space-between;}
.os_noticeRes .NCAcmi_cont01_input input{width:55%;}
.os_noticeRes .NCAcmi_cont01_wrap .NCAcmi_cont01-2{display:flex; align-items: center; justify-content: flex-end;}

.os_noticeRes .NCAcmi_cont01-1 label, .os_noticeRes .NCAcmi_cont01-2 label{color:#56565A; margin-bottom:0;}
.os_noticeRes .NCAcmi_cont01_file01{display:flex; justify-content: space-between; align-items: center; color:#56565A; margin-bottom:0;}
.os_noticeRes .NCAcmi_cont01_file01 span.NCAcmi_fileBtn, .os_noticeRes .NCAcmi_cont01_file02 span.NCAcmi_fileBtn{background: #7d8c9b; border-radius: 5px; font-weight: 500; color: #fff; height: 40px; text-align: center; padding-top: 0.5em; width:55%; display:inline-block;}
.os_noticeRes .NCAcmi_cont01_file01 span.NCAcmi_fileBtn.disabled, .os_noticeRes .NCAcmi_cont01_file02 span.NCAcmi_fileBtn.disabled {color: #fff; border-color: #bbb !important; background: #bbb !important;}
.os_noticeRes .NCAcmi_cont01_file02{display:flex; justify-content: end; align-items: center; color:#56565A; margin-bottom:0;}

.os_noticeRes .NCAcmi_cont01_wrap .NCAcmi_cont01-2.NCAcmi_pc{height:71px;}
.os_noticeRes input.NCAcmi_num[type="number"]{padding:0 8px;}

.os_noticeRes input.NCAcmi_num[type="number"]::-webkit-outer-spin-button, .os_noticeRes input.NCAcmi_num[type="number"]::-webkit-inner-spin-button {-webkit-appearance: none; margin: 0;}

.os_noticeRes .NCAcmi_file02-1_wrap{border-bottom:1px solid #e3e3e3;}
.os_noticeRes .NCAcmi_blankR label{height:85px; display: flex; align-items: flex-start; margin-top: 5px;}
.os_noticeRes .NCAcmi_lineBtm{border-bottom:1px solid #e3e3e3;}
.os_noticeRes .NCAcmi_none{display:none !important;}

/* 참가 약관 동의 */
.os_noticeRes .NCAcmi_cont02_radio label .amw-label-radio-text{font-size:18px; font-weight:normal; position:relative;}
.os_noticeRes .NCAcmi_cont02{display: flex; align-items: center; justify-content: space-between;}
.amway-theme .NCAcmi_cont02_radio label.amw-radio-wrap .amw-radio-overlay{top:3px;}

/* 참가 약관 동의 팝업 공통 */
.NCAcmi_cont02_popUp .cart-popup__header{background:#fff;}
.NCAcmi_cont02_popUp .cart-popup__item-info{border-top:1px solid #ddd;}
.os_noticeRes .NCAcmi_cont02_popUp thead th{ color:#00305e; font-weight:500; background:#f4f4f4;}

.os_noticeRes .NCAcmi_cont02_popUp tbody tr td:nth-child(3){color:#2c2c2c; font-weight:500; font-size:17px;}
.os_noticeRes .NCAcmi_cont02_popUp tbody tr:nth-child(even){background:#f4f4f4;}

/* 제출 */
.bt-akl-blue.large.NCAcmi_submit{width:100%; background:#00305e; border: 1px solid #00305e; border-radius:5px;}
.os_noticeRes .bt-akl-blue.NCAcmi_submit:hover{border:1px solid #00305e; color:#00305e; background:#fff;}

.bt-akl-blue.btn_close.NCAcmi_cont03_popup{color:#fff;}
.bt-akl-blue.btn_close.NCAcmi_cont03_popup:hover{color:#002F5F;}

/* file Box */
.NCAcmi_cont01_file01.NCAcmiFile_remove{justify-content: flex-end;}
.NCAcmi_cont01_file01.NCAcmiFile_remove input{height: 40px; width: 55%; border-radius: 5px; padding-right: 30px;}
.NCAcmi_cont01_file01 a{position:absolute; background:none; padding-right:8px;}

@media screen and (max-width:639px) {
  .os_noticeRes .widM.cont_Wrap{width:100%;}
  .os_noticeRes .NCAcmi_cont02 .floL, .os_noticeRes .NCAcmi_cont02 .floR{margin:0;}

  .os_noticeRes .NCAcmi_cont01_wrap .NCAcmi_cont01-2, .os_noticeRes .NCAcmi_cont01_file02{display:flex; align-items: center; justify-content: space-between;}
  .os_noticeRes .NCAcmi_cont01_wrap .NCAcmi_cont01-1 .amway-theme label:nth-child(2), .os_noticeRes .NCAcmi_cont01_wrap .NCAcmi_cont01-2 .amway-theme label:nth-child(2){margin-right:1.5em;} 
  .os_noticeRes .NCAcmi_cont01_radio label .amw-label-radio-text{top:0;}
  .os_noticeRes .NCAcmi_cont01_file01 span.NCAcmi_fileBtn, .os_noticeRes .NCAcmi_cont01_file02 span.NCAcmi_fileBtn{padding-top:.7em;}
  .os_noticeRes .NCAcmi_cont01_radio label .amw-label-radio-text, .os_noticeRes .NCAcmi_cont02_radio label .amw-label-radio-text{font-size:16px;}
  .os_noticeRes .NCAcmi_cont01_wrap .NCAcmi_cont01-2.NCAcmi_pc{display:none;}

  .os_noticeRes .NCAcmi_cont01_wrap.widM{width:100%;}
  .os_noticeRes .NCAcmi_cont01_wrap.widM .floL, .os_noticeRes .NCAcmi_cont01_wrap.widM .floR{width:95% !important; margin:0 auto;}

  .os_noticeRes .NCAcmi_cont02_popUp tbody tr td:nth-child(3){color:#2c2c2c; font-weight:500; font-size:16px;}
  .os_noticeRes .NCAcmi_last{border-bottom:none;}
  .os_noticeRes .NCAcmi_blankR{display:none;}
  .os_noticeRes .NCAcmi_file02-1_wrap.NCAcmi_last{border-bottom:none;}
}

    

/* 동반 가족 정보 */
.NCAcmi_family_attend > div{width:55%; position:relative; left:45%; overflow: hidden;}
@media screen and (max-width:639px) {
  .NCAcmi_family_attend.floR{width:55% !important;}
  .NCAcmi_family_attend > div{width:100%; left:0; overflow: hidden;} 
  .NCAcmi_family_attend > div label:nth-child(2){margin-right:1.5em;}
}

.os_noticeRes .NCAcmi_family_radio label .amw-label-radio-text{font-size:18px; font-weight:normal; position:relative;}
.os_noticeRes .NCAcmi_family{display: flex; align-items: center; justify-content: space-between;}
.amway-theme .NCAcmi_family_radio label.amw-radio-wrap .amw-radio-overlay{top:3px;}
.NCAcmi_familyN_num { left: 45%; width: 55%; position: relative; } 
.NCAcmi_familyN_file { width: 55%; background: #7d8c9b; border-radius: 5px; font-weight: 500; color: #fff; height: 40px; text-align: center; padding-top: 0.5em; display: inline-block; } 
.os_noticeRes .NCAcmi_familyN { display: flex; align-items: center; justify-content: space-between; } 
.os_noticeRes .NCAcmi_familyN label { margin-bottom: 0; color: #56565A; font-size: 16px; font-weight: 400; } 
.os_noticeRes .NCAcmi_familyN_input input { width: 55%; } 
.os_noticeRes .NCAcmi_familyN_fileBox { display: flex; justify-content: space-between; align-items: center; color: #56565A; margin-bottom: 0; } 
.NCAcmi_familyN_fileBox.NCAcmiFile_remove { justify-content: flex-end; } 
.NCAcmi_familyN_fileBox.NCAcmiFile_remove input { height: 40px; width: 55%; border-radius: 5px; padding-right: 30px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;} 
.os_noticeRes .NCAcmi_familyN_fileWrap span.NCAcmi_familyN_file { padding-top: 0.5em; }
.os_noticeRes .NCAcmi_familyN_fileWrap span.NCAcmi_familyN_file.disabled {color: #fff; border-color: #bbb !important; background: #bbb !important;}
a.NCAcim_familyN_plus{background:#56555a;  border-radius:8px; width:100%; display:block;}
a.NCAcim_familyN_plus.NCAcmi_familyN_Btn{background:#777;}
.NCAcmi_family_delete{background:none; display:flex;align-items: center;}

/* 동반 가족 결제 팝업 */
.os_noticeRes .NCAcmi_payCard_wrap .NCAcmi_payCard{display:flex; align-items: center; justify-content: space-between;}
.os_noticeRes .NCAcmi_payCard_input input, .os_noticeRes .NCAcmi_payCard_input:nth-child(6) select{width:50%;}
.os_noticeRes .NCAcmi_payCard label, .os_noticeRes .NCAcmi_payCard .NCAcmi_cardlist{color:#56565A; margin-bottom:0;}
.NCAcmi_payCard_input select.form-control{color:#808285; background: url("./images/NCAcmi_cardArrow.jpg") right center no-repeat #ffffff;}

.NCAcmi_check {width: 50%;}
.NCAcmi_check [type=checkbox]:checked+label::before{background:url("./images/NCAcmi_checkBox.png"); background-size:cover; border:none;}
.NCAcmi_check [type=checkbox]:checked+label::after{display:none;}

.akl button.NCAcmi_paySubmit[disabled]:hover{color:#fff;}
.akl .amway-theme .NCAcmi_payCard_input label{font-size:16px; font-weight:normal;}
.NCAcmi_payCard_wrap .NCAcmi_payCard:nth-child(1) .NCAcmi_check label{font-size:12px;}
.NCAcmi_check [type="checkbox"]:not(:checked)+label, .NCAcmi_check [type="checkbox"]:not(:checked)+label, .NCAcmi_check [type="checkbox"]:checked+label{margin:0;}
.NCAcmi_payCard_p{font-size:16px; color: #56565A;}
.bt-akl-blue.large.NCAcmi_submit.NCAcmi_submitNope{border: 1px solid #bbb; background:#bbb; color:#fff;}

@media screen and (max-width:639px) {
  .os_noticeRes .NCAcmi_family .floL, .os_noticeRes .NCAcmi_family .floR{margin:0;}
  .os_noticeRes .NCAcmi_family_radio label .amw-label-radio-text{font-size:16px;}
  .akl .amway-theme .NCAcmi_payCard_input label{font-size:15px; font-weight:normal;}
  .os_noticeRes .NCAcmi_familyN .floL { width: 45% !important; } 
  .os_noticeRes .NCAcmi_familyN .floR { width: 55% !important; } 
  .os_noticeRes .NCAcmi_familyN label { font-size: 15px; } 
  .os_noticeRes .NCAcmi_familyN .floR input { width: 100%; }
  .os_noticeRes .NCAcmi_familyN_fileWrap span.NCAcmi_familyN_file {padding-top: 0.7em;}
  .NCAcmi_familyN_num { width: 100% !important; left: 0; } 
  .NCAcmi_familyN_file { width: 100%; } 
  .os_noticeRes .NCAcmi_familyN .floL, .os_noticeRes .NCAcmi_familyN .floR { margin: 0; } 
  .NCAcim_familyN_plus{width:95%;}
  .NCAcmi_payCard_p{font-size:15px; color: #56565A;}
  }

/* 액비비티 참여자명 */
.os_noticeRes .NCAcmi_nameBox_wrap .NCAcmi_nameBox{display:flex; align-items: center; justify-content: space-between; border-bottom:1px solid #e3e3e3;}
.os_noticeRes .NCAcmi_nameBox_input input{width:55%; padding:0 13px;}
.os_noticeRes .NCAcmi_nameBox label{color:#56565A; margin-bottom:0;}

/* 액티비티 예약 */
.os_noticeRes a.NCAcmi_arrow{width:100%; border-radius:5px; padding:1em 0;}
.os_noticeRes .NCAcmi_cont03_radio label .amw-label-radio-text em{color:#808285;}
.amway-theme .NCAcmi_cont03_radio input.amw-global-radio{top:0; width:18px; height:18px;}
.os_noticeRes .NCAcmi_cont03_radio .radio-label + .radio-label{margin-left:0 !important;}
.os_noticeRes .NCAcmi_cont03_radio label .amw-label-radio-text{font-size:18px; font-weight:normal; position:relative; top:-3px;}
.os_noticeRes .amway-theme .NCAcmi_cont03_radio label{margin-bottom:.7em !important;}

/* 액티비티 예약 체크박스 */
.akl .NCAcmi_nameBox_input input{border-color:#dadada !important;}
.NCAcmi_check [type="checkbox"]:checked + label{color:#56565A}
.os_noticeRes .NCAcmi_checkWrap{display:flex; margin-left:2.2em; justify-content: space-between; flex-wrap: wrap;}
.os_noticeRes .NCAcmi_checkWrap span.NCAcmi_time{width:45px;}


 /* 액티비티 예약 radio off */
.os_noticeRes .NCAcmi_cont03_radio label.NCAcmi_radio_off .amw-label-radio-text, .akl .NCAcmi_cont03_radio label.NCAcmi_radio_off .amw-label-radio-text em, label.NCAcmi_radio_off em span.colorGray{color:#bbbbbb !important;}
.os_noticeRes .amway-theme label.amw-radio-wrap.NCAcmi_radio_off .amw-radio-overlay{background:#f4f4f4; border:1px solid #ddd;}

/* 액티비티 예약 table */
.os_noticeRes .NCAcmi_table tbody tr td{vertical-align:middle;}
.os_noticeRes .NCAcmi_table .osResTb05 thead th{color:#00305e; font-weight:bold;}

@media screen and (max-width:639px) {
  .os_noticeRes .NCAcmi_table .osResTbBlock{width:150%; border-top: 2px solid #0E4C88;}
  .os_noticeRes .osResTbScrollWrap.NCAcmi_table{border:none;}
  .os_noticeRes .NCAcmi_checkWrap span.NCAcmi_time{width:40px;}
}

/* 221017 style 추가 */
.akl select.form-control.NCAcmi_attendNum_box[disabled]{border-color: #dadada !important; color:#bbb; background: url("./images/NCAcmi_arrowbg.jpg") right center no-repeat #f4f4f4 !important; font-size:14px !important;}
select.form-control.NCAcmi_attendNum_box{color:#2c2c2c; background: url("./images/NCAcmi_cardArrow.jpg") right center no-repeat #ffffff; width:100%; font-size:14px !important;}
select.form-control.NCAcmi_attendNum_box option[disabled]{color:#bbb;}
.NCAcmi_nameBox_wrap .NCAcmi_nameBox input::placeholder {font-size: 14px;}

select.form-control.NCAcmi_attendNum_box:focus{background:url("./images/NCAcmi_cardArrow_up.jpg") right center; background-repeat:no-repeat;}

.akl [type="checkbox"]:not(:checked) + label::before {top: 2.5px;}

@media screen and (max-width:639px) {
  .os_noticeRes .NCAcmi_cont03_radio label .amw-label-radio-text{font-size:16px; font-weight:normal; position:relative; top:-3px;}
  .akl [type="checkbox"]:not(:checked) + label::before {top: 1px;}
}

/* 221102 style 추가 */
.os_noticeRes .osResBtn01.NCAcmi_interestFree {padding: .3em 1em .3em; font-size:14px; max-width:6em; width:28%; text-align:center; margin-left:5px;}
</style>


// WEBPACK FOOTER //
// src/views/survey2/Survey.vue